module.exports = __webpack_public_path__ + "img/adv_on.7eb3bb06.png";